import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login";//登录
import Home from "@/pages/Home";//菜单
import Index from "@/pages/index";//首页
import Error from "@/pages/error";//空页面
import Permission from "@/pages/develop/permission";//权限管理
import Menus from "@/pages/develop/menus";//菜单管理
import Role from "@/pages/admin/role";//角色管理
import Admin from "@/pages/admin/index";//管理员管理
import Password from "@/pages/admin/password";//管理员密码
import Goods from "@/pages/goods";// 商品管理
import GoodsLevel from "@/pages/goods/goodsLevel";//商品等级
import cate from "@/pages/goods/cate";//盲盒分类
import BlindBox from "@/pages/blind/index";//无限池列表
import pk from "@/pages/pk/index";//pk
import challenge from "@/pages/challenge/index";//擂台列表
import LuckDraws from "@/pages/luck/index.vue";//幸运屋列表
import Image from "@/pages/content/image";//图片管理
import WealRooms from "@/pages/weal/index";//福利屋列表
import wishBox from "@/pages/wishBox/index";//许愿池列表
import fight from "@/pages/fight/index.vue";//闯关列表
import climbTower from "@/pages/climbTower/index";//爬塔管理
import users from "@/pages/user/index";// 用户管理
import UserLevel from "@/pages/user/userLevel";//用户等级配置
import userCoupon from "@/pages/user/userCoupon";//用户优惠券
import userCharge from "@/pages/user/userCharge";//用户充值
import energyLog from "@/pages/user/energyLog";//用户能量记录
import fusionLog from "@/pages/user/fusionLog";//用户融合记录
import userPrize from "@/pages/user/userPrize";//用户赏袋
import giveOrder from "@/pages/user/giveOrder";//赠礼记录
import customCommission from "@/pages/user/customCommission";//用户定制返佣列表
import prizeLog from "@/pages/user/prizeLog";//用户赏袋日志
import Task from "@/pages/operate/task";//任务列表
import run_task from "@/pages/operate/run_task";//运行任务
import Coupon from "@/pages/operate/coupon";//优惠券
import BalanceLog from "@/pages/log/balanceLog";//余额日志
import blindPointLog from "@/pages/log/blindPointLog";//无限币记录
import challengePointLog from "@/pages/log/challengePointLog";//擂台币记录
import fightPointLog from "@/pages/log/fightPointLog";//闯关币记录
import pkPointLog from "@/pages/log/pkPointLog";//PK币记录
import bl from "@/pages/log/bl";//B列表
import wl from "@/pages/log/wl";//W列表
import pointLog from "@/pages/log/pointLog";//钻石日志
import api_request from "@/pages/log/api_request";//qpi请求日志
import adminRecharge from "@/pages/log/adminRecharge";//后台充值日志
import signRecord from "@/pages/log/signRecord";//后台充值日志
import userLevelLog from "@/pages/log/userLevelLog";//用户等级日志
import blindPrizeSet from "@/pages/system/blindPrizeSet";//区间配置
import systemConfig from "@/pages/system/systemConfig";//系统配置
import treasurePrize from "@/pages/box/treasurePrize";//宝箱
import fusionPrize from "@/pages/fusionPrize/index";//融合
import shopGoods from "@/pages/shopGoods/index";//商城
import givePoint from "@/pages/givePoint/index";//流水赠送配置列表
import signPanel from "@/pages/signPanel/index";//签到配置列表
import flowReward from "@/pages/signPanel/flowReward";//连续7天流水达标奖励列表
import userGiveLimit from "@/pages/signPanel/userGiveLimit";//用户赠送限额配置
import vipRechargeSet from "@/pages/signPanel/vipRechargeSet";//连续7天流水达标奖励列表
import contentCte from "@/pages/content/contentCte";//内容分类
import cobtent from "@/pages/content/cobtent";//编辑内容
import banners from "@/pages/content/banners";//轮播内容
import loss from "@/pages/loss/index";//亏损
import flowRank from "@/pages/loss/flowRank";//排行榜
import userPrizeData from "@/pages/loss/userPrizeData";//用户赏袋数据
import busnissOrder from "@/pages/loss/busnissOrder";//业务订单数据
import superHuman from "@/pages/loss/superHuman";//首个超神
import userAttendNum from "@/pages/loss/userAttendNum";//用户上车次数
import userLossByType from "@/pages/loss/userLossByType";//用户类型亏损
import pkroomrecord from "@/pages/loss/pkroomrecord";//pk房间记录
import rechargeWealRoom from "@/pages/rechargeWealRoom/index";//充值福利屋
import areas from "@/pages/areas/index";//配送区域列表
import freight from "@/pages/areas/freight";//配送运费列表
import shopOrder from "@/pages/goods/shopOrder";//配送运费列表
import theme from "@/pages/theme/index";//活动主题
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  routes: [//
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "fight",
          name: "fight",
          component: fight
        },
        {
          path: "flowReward",
          name: "flowReward",
          component: flowReward
        },
        {
          path: "vipRechargeSet",
          name: "vipRechargeSet",
          component: vipRechargeSet
        },
        {
          path: "userGiveLimit",
          name: "userGiveLimit",
          component: userGiveLimit
        },
        {
          path: "luckDraw",
          name: "luckDraw",
          component: LuckDraws
        },
        {
          path: "userPrizeData",
          name: "userPrizeData",
          component: userPrizeData
        },
        {
          path: "superHuman",
          name: "superHuman",
          component: superHuman
        },
        {
          path: "bl",
          name: "bl",
          component: bl
        },
        {
          path: "wl",
          name: "wl",
          component: wl
        },
        {
          path: "rechargeWealRoom",
          name: "rechargeWealRoom",
          component: rechargeWealRoom
        },
        {
          path: "flowRank",
          name: "flowRank",
          component: flowRank
        },
        {
          path: "userAttendNum",
          name: "userAttendNum",
          component: userAttendNum
        },
        {
          path: "busnissOrder",
          name: "busnissOrder",
          component: busnissOrder
        },
        {
          path: "userLossByType",
          name: "userLossByType",
          component: userLossByType
        },
        {
          path: "customCommission",
          name: "customCommission",
          component: customCommission
        },
        {
          path: "theme",
          name: "theme",
          component: theme
        },
        {
          path: "blindPointLog",
          name: "blindPointLog",
          component: blindPointLog
        },
        {
          path: "challengePointLog",
          name: "challengePointLog",
          component: challengePointLog
        },
        {
          path: "fightPointLog",
          name: "fightPointLog",
          component: fightPointLog
        },
        {
          path: "pkPointLog",
          name: "pkPointLog",
          component: pkPointLog
        },
        {
          path: "pkroomrecord",
          name: "pkroomrecord",
          component: pkroomrecord
        },
        {
          path: "userPrize",
          name: "userPrize",
          component: userPrize
        },
        {
          path: "shopOrder",
          name: "shopOrder",
          component: shopOrder
        },
        {
          path: "signPanel",
          name: "signPanel",
          component: signPanel
        },
        {
          path: "signRecord",
          name: "signRecord",
          component: signRecord
        },
        {
          path: "challenge",
          name: "challenge",
          component: challenge
        },
        {
          path: "api_request",
          name: "api_request",
          component: api_request
        },
        {
          path: "goodsLevel",
          name: "GoodsLevel",
          component: GoodsLevel
        },
        {
          path: "pk",
          name: "pk",
          component: pk
        },
        {
          path: "freight",
          name: "freight",
          component: freight
        },
        {
          path: "loss",
          name: "loss",
          component: loss
        },
        {
          path: "cate",
          name: "cate",
          component: cate
        },
        {
          path: "areas",
          name: "areas",
          component: areas
        },
        {
          path: "shopGoods",
          name: "shopGoods",
          component: shopGoods
        },
        {
          path: "givePoint",
          name: "givePoint",
          component: givePoint
        },
        {
          path: "cobtent",
          name: "cobtent",
          component: cobtent
        },
        {
          path: "banners",
          name: "banners",
          component: banners
        },
        {
          path: "index",
          name: "index",
          component: Index
        },
        {
          path: "contentCte",
          name: "contentCte",
          component: contentCte
        },
        {
          path: "wishBox",
          name: "wishBox",
          component: wishBox
        },
        {
          path: "admins",
          name: "admin",
          component: Admin
        },
        {
          path: "rolse",
          name: "role",
          component: Role
        },
        {
          path: "permission",
          name: "permission",
          component: Permission
        },
        {
          path: "energyLog",
          name: "energyLog",
          component: energyLog
        },
        {
          path: "fusionLog",
          name: "fusionLog",
          component: fusionLog
        },
        {
          path: "menus",
          name: "menus",
          component: Menus
        },
        {
          path: "password",
          name: "password",
          component: Password
        },
        {
          path: "fusionPrize",
          name: "fusionPrize",
          component: fusionPrize
        },
        {
          path: "goods",
          name: "goods",
          component: Goods
        },
        {
          path: "giveOrder",
          name: "giveOrder",
          component: giveOrder
        },
        {
          path: "blindPrizeSet",
          name: "blindPrizeSet",
          component: blindPrizeSet
        },
        {
          path: "systemConfig",
          name: "systemConfig",
          component: systemConfig
        },
        {
          path: "users",
          name: "users",
          component: users
        },
        {
          path: "treasurePrize",
          name: "treasurePrize",
          component: treasurePrize
        },
        {
          path: "blindBox",
          name: "blindBox",
          component: BlindBox
        },
        {
          path: "climbTower",
          name: "climbTower",
          component: climbTower
        },
        {
          path: "wealRooms",
          name: "wealRooms",
          component: WealRooms
        },
        {
          path: "userLevel",
          name: "userLevel",
          component: UserLevel
        },
        {
          path: "userCharge",
          name: "userCharge",
          component: userCharge
        },
        {
          path: "prizeLog",
          name: "prizeLog",
          component: prizeLog
        },

        {
          path: "userCoupon",
          name: "userCoupon",
          component: userCoupon
        },
        {
          path: "image",
          name: "image",
          component: Image
        },
        {
          path: "coupon",
          name: "coupon",
          component: Coupon
        },

        {
          path: "balanceLog",
          name: "balanceLog",
          component: BalanceLog
        },
        {
          path: "pointLog",
          name: "pointLog",
          component: pointLog
        },
        {
          path: "adminRecharge",
          name: "adminRecharge",
          component: adminRecharge
        },
        {
          path: "userLevelLog",
          name: "userLevelLog",
          component: userLevelLog
        },
        {
          path: "task",
          name: "task",
          component: Task
        },
        {
          path: "run_task",
          name: "run_task",
          component: run_task
        }
      ]
    },

    {
      path: "*",
      name: "error",
      component: Error
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js